import { isArray } from '@cutwise/utils';

type FormDataValue = string | Blob;

export default class ToFormDataSerializationStrategy {
  static serialize(data: Record<string, FormDataValue | FormDataValue[]>) {
    if (!data) {
      return null;
    }

    const formData = new FormData();

    Object.keys(data).forEach((dataObjectKey) => {
      const value = data[dataObjectKey];

      if (isArray<FormDataValue>(value)) {
        value.forEach((item) => {
          formData.append(dataObjectKey, item);
        });
      } else {
        formData.append(dataObjectKey, value);
      }
    });

    return formData;
  }

  static contentType() {
    return null;
  }
}
